import { Skeleton } from '@/components/ui/Skeleton';
import { cn } from '@/lib/utils';

export interface CasosListSkeletonProps {
  /** Quantidade de linhas exibidas. Default 8. */
  rows?: number;
  className?: string;
}

export function CasosListSkeleton({ rows = 8, className }: CasosListSkeletonProps) {
  return (
    <div data-testid="casos-list-skeleton" className={cn('flex flex-col gap-2', className)}>
      {/* cabeçalho da tabela */}
      <Skeleton className="h-9 w-full" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full" data-testid="casos-list-skeleton-row" />
      ))}
    </div>
  );
}
